<template>
  <div style="height: 100%;">
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>停车场实时总览</span>
    </div>
    <div
      style="display: flex;flex-direction: row;flex-wrap: wrap;align-items: center; height: 70%;width: 100%;">
      <ul style="padding-left: 16%;text-align: center;">
        <li><span class="carFont">总停车位 : </span><span class="carNumber"> {{ totalPark }}</span></li>
      </ul>
      <ul style="padding: 20px;">

      </ul>
      <ul>
        <li><span class="carFont">空停车位 : </span><span class="carNumber"> {{ emptyTotalPark }}</span></li>
      </ul>
      <ul style="padding-left: 16%">
        <li><span class="carFont">今日收入 : </span><span class="carNumber"> {{ incomePark }}</span><span style="font-size: 7px"> 元</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
import {getParkingPandect} from '../../../network/parking.js'

export default {
  name: "CarAccessMonitoring",
  components: {},
  data() {
    return {
      //获取总览数据面板定时器
      getParkingPandectInterval: null,
      // 总停车位
      totalPark: 0,
      // 空停车位
      emptyTotalPark: 0,
      // 车场收入
      incomePark: 0,
    }
  },
  methods: {
    async getParkingPandectMethod(param) {
      await getParkingPandect(param).then(res => {
        if (res.data != null) {
          //轮询判断是否值有改变
          if (this.totalPark == res.data.total &&
            this.emptyTotalPark == res.data.remainTotal &&
            this.incomePark == res.data.incomePark) {
            return;
          } else {
            this.totalPark = res.data.total;
            this.emptyTotalPark = res.data.remainTotal;
            this.incomePark = res.data.incomePark;
          }
        }
      })
    }
  },
  mounted() {
    this.getParkingPandectMethod();
    this.getParkingPandectInterval =
      setInterval(
        () => this.getParkingPandectMethod(), 5000)
  },
  created() {
    clearInterval(this.getParkingPandectInterval)
    this.getParkingPandectInterval = null;
  },
  destroyed() {
    clearInterval(this.getParkingPandectInterval)
    this.getParkingPandectInterval = null;
  }

}
</script>

<style scoped>
ul li {
  list-style: none;
  margin: 0;
}

ul {
  text-align: center;
  padding: 0;
}

.carNumber {
  margin: 0;
  font-size: 28px;
  color: #07E6F8;
  opacity: 1;
}

.carFont {
  font-size: 14px;
  color: #FFFFFF;
  display: inline-block;
}

.bar {
  width: 1px;
  height: 24px;
  border: 1px solid #FFFFFF;
  opacity: 0.2;
  display: block;
  margin: 0;
}
</style>
